




















import { Component, Watch, Vue } from "vue-property-decorator";

import { defaultLinks, defaultMeta } from "./const";

import PageTitle from "@/components/common/PageTitle.vue";

import { GRD } from "@/services/consts";
import { IPageMeta } from "@/services/interfaces";

import { personalModule } from "@/plugins/store-accessors";

@Component({
  components: {
    PageTitle,
  },
})
export default class AccountPage extends Vue {
  meta: IPageMeta = defaultMeta;
  links = defaultLinks;

  get isAuthorized() {
    return personalModule.isAuthorized;
  }

  @Watch("isAuthorized")
  authGuard(state: boolean) {
    state ? this.sendRequest() : this.openModal();
  }

  openModal() {
    personalModule.showLoginModal(GRD.order);
  }

  logout() {
    personalModule.forceLogout();
  }

  sendRequest() {
    return null;
  }

  setMeta() {
    document.title = this.meta.title as string;
  }

  mounted() {
    this.authGuard(this.isAuthorized);
    this.setMeta();
  }
}
